class HTMLLink {

  constructor(
    readonly label: string,
    readonly url: string,
    readonly isProtected : boolean = false
  ) {}
}

export { HTMLLink }